import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/accounting/documents` — kept as a signpost.
 *
 * Issued and received documents now have their own places (Invoices and
 * Expenses), the way people look for them. Old links still work: this
 * route sends them where the documents moved, keeping the side they
 * asked for.
 */
export const Route = createFileRoute("/_app/accounting/documents")({
  beforeLoad: ({ search }) => {
    const side = (search as { side?: string }).side;
    throw redirect({ to: side === "received" ? "/accounting/expenses" : "/accounting/invoices" });
  },
});
